"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var Item_1 = __importDefault(require("../Item/Item"));
var Menu_1 = __importDefault(require("semantic-ui-react/dist/commonjs/collections/Menu"));
/**
 * The Submenu is used to create nested menus.
 */
function Submenu(props) {
    var icon = props.icon, iconRoot = props.iconRoot, content = props.content, open = props.open, alwaysOpen = props.alwaysOpen, children = props.children, onClick = props.onClick, name = props.name, activeName = props.activeName, BadgeProps = props.BadgeProps, active = props.active, rest = __rest(props, ["icon", "iconRoot", "content", "open", "alwaysOpen", "children", "onClick", "name", "activeName", "BadgeProps", "active"]);
    var genClasses = function () {
        var open = props.open, alwaysOpen = props.alwaysOpen, className = props.className;
        var classes = 'submenu';
        if (open || alwaysOpen) {
            classes += ' open';
        }
        if (className) {
            classes += " " + className;
        }
        return classes;
    };
    var itemProps = {
        icon: icon,
        iconRoot: iconRoot,
        content: content,
        onClick: onClick,
        name: name,
        BadgeProps: BadgeProps
    };
    return (React.createElement("div", __assign({ className: genClasses() }, rest),
        React.createElement(Item_1.default, __assign({}, itemProps, (!alwaysOpen ? { open: open } : {}))),
        React.createElement(Menu_1.default, { vertical: true }, children)));
}
Submenu.defaultProps = {
    active: false,
    open: false,
    iconRoot: 'common'
};
exports.default = Submenu;
